import React, { useEffect } from 'react';

import constants from 'constants/constants';

import useUserHook from 'hooks/useUserHook';

import { useGlobalFilterDataStore } from 'store/globalFilterData.store';

import { Badge } from 'components/common/Badge/badge';
import { CustomizedRoundIcon } from 'components/common/CustomizedRoundIcon/CustomizedRoundIcon';
import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { TooltipPosition } from 'components/common/CustomizedTooltip/customizedTooltip.enums';
import classes from 'components/common/GlobalFilterButton/GlobalFilterButton.module.scss';
import { getActiveFilterCount } from 'components/common/GlobalFilterComponent/GlobalFilterComponent.utils';
import Icon from 'components/common/Icons/base/Icon/Icon';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';

import { Button } from 'components/DesignSystem/Button';

type TGlobalFilterStatus = {
    showFilterToggleButton: boolean;
    isFilterExpanded: boolean;
};

export const GlobalFilterButton = () => {
    const toggleGlobalFilterComponent = useGlobalFilterDataStore((store) => store.toggleGlobalFilterComponent);
    const globalFilterData = useGlobalFilterDataStore((store) => store.globalFilterData);
    const defaultValues = useGlobalFilterDataStore((store) => store.defaultValues);
    const { setToggleGlobalFilterComponent } = useGlobalFilterDataStore();
    const activeFilterCount = getActiveFilterCount(globalFilterData, Object.keys(defaultValues));
    const { globalFilterStatus } = useUserHook();
    const { showFilterToggleButton, isFilterExpanded } = globalFilterStatus as TGlobalFilterStatus;

    useEffect(() => {
        setToggleGlobalFilterComponent(isFilterExpanded);
    }, [showFilterToggleButton, isFilterExpanded]);

    return null;
    return (
        <>
            {showFilterToggleButton && (
                <div className={classes.globalFilterButtonContainer}>
                    <CustomizedTooltip
                        tooltipPosition={TooltipPosition.Top}
                        tooltipContent={`Show/Hide Filter Pane`}
                        triggerElement={
                            <CustomizedRoundIcon
                                size={'40px'}
                                onClick={() => {
                                    setToggleGlobalFilterComponent(!toggleGlobalFilterComponent);
                                }}
                            >
                                <Icon name={'filter'} size={'18px'} color={'var(--text-primary)'} />
                                <div className={classes.badge}>
                                    <Badge count={activeFilterCount} />
                                </div>
                            </CustomizedRoundIcon>
                        }
                    />
                </div>
            )}
        </>
    );
};
